export const STRING_SCAN_POSITION = "Escaneie a Posição";
export const STRING_SCAN_ORDER_OR_POSITION =
  "Escaneie um pedido para adicioná-lo ou uma posição para confirmar";
export const STRING_SCAN_BOX =
  "Por Favor, faça a leitura da caixa com o pedido.";
export const PERIOD_NAMES = Object.freeze({
  MORNING: "manhã",
  AFTERNOON: "tarde",
  NIGHT: "noite",
});

export const PRODUCT_LOSS_PROCESSES = {
  DEVOLUTION: 'Retorno de Pedidos',
  OTHER: 'Retirada Eventual',
  PICKING_REPLENISHMENT: 'Reabastecimento de Picking',
  PICKING: 'Picking',
  PORTFOLIO: 'Retirada por Portfólio',
  QUALITY: 'Retirada por Qualidade',
  RECEIVING: 'Recebimento',
}

export const PRODUCT_LOSS_REASONS = {
  [PRODUCT_LOSS_PROCESSES.DEVOLUTION]: [
    'Embalagem rasgada',
    'Item amassado',
    'Embalagem manchada',
    'Fora de temperatura',
    'Amostragem de qualidade',
  ],
  [PRODUCT_LOSS_PROCESSES.OTHER]: [
    'Falha de Infraestrutura',
    'Erro Operacional',
  ],
  [PRODUCT_LOSS_PROCESSES.PICKING_REPLENISHMENT]: [
    'Embalagem rasgada',
    'Falha na Selagem',
    'Item amassado',
    'Etiqueta errada',
    'Embalagem manchada',
  ],
  [PRODUCT_LOSS_PROCESSES.PICKING]: [
    'Embalagem rasgada',
    'Falha na Selagem',
    'Item amassado',
    'Etiqueta errada',
    'Embalagem manchada',
  ],
  [PRODUCT_LOSS_PROCESSES.PORTFOLIO]: [
    'Retirada de portfólio'
  ],
  [PRODUCT_LOSS_PROCESSES.QUALITY]: [
    'Contaminação física',
    'Contaminação cruzada',
    'Desvio sensorial',
    'Desvio microbiológico',
    'Desvio de peso',
    'Próximo à validade',
  ],
  [PRODUCT_LOSS_PROCESSES.RECEIVING]: [
    'Embalagem rasgada',
    'Falha na Selagem',
    'Item amassado',
    'Etiqueta errada',
    'Embalagem manchada',
  ],
}
